"use client";

import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState,
} from 'react';

import { captureSignupAttribution } from '@/services/utm';

interface StateContextType {
    unreadCount: number
    setUnreadCount: (n: number) => void
    refreshUnreadCount: () => Promise<void>
}

const StateContext = createContext<StateContextType>({} as StateContextType);

export function useContextState() { return useContext(StateContext); }

function StateProvider({ children }: { children: React.ReactNode }) {
    const [unreadCount, setUnreadCount] = useState(0);

    const refreshUnreadCount = useCallback(async () => {
        try {
            const { getUnreadCount } = await import('@/services');
            const count = await getUnreadCount();
            setUnreadCount(count);
        } catch {}
    }, []);

    return <StateContext.Provider value={{ unreadCount, setUnreadCount, refreshUnreadCount }}>
        <div className="wrapper"> {children} </div>
    </StateContext.Provider>
}

export default function Layout({ children }: { children: React.ReactNode }) {
    // Captured at the outermost client boundary so a partner link lands
    // wherever it points — the landing page, /auth/registration, a blog post —
    // rather than only on the home page.
    useEffect(() => { captureSignupAttribution(); }, []);

    return <StateProvider> {children} </StateProvider>
}
